<template>
  <div :data-template="content?.['mgnl:template']">
    <PageLayout>
      <ClientOnly>
        <EditorAnnotationElements v-if="isEditMode && !isComponentPreview()" />
      </ClientOnly>

      <Suspense>
        <EditablePage
          :config="config"
          :content="content"
          :template-annotations="templateAnnotations"
          :magnolia-context="editorContext"
        />
        <!-- component with nested async dependencies -->
        <!-- loading state via #fallback slot -->
        <template #fallback>
          <LoadingElement class="container aspect-2/3 lg:aspect-video" />
        </template>
      </Suspense>
    </PageLayout>
  </div>
</template>

<script setup>
import { isComponentPreview } from "~/utils/content/magnolia";
import { componentMappings } from "~/utils/config/components";
import { DefaultFallbackComponent, EditablePage } from "@magnolia/vue-editor";
import { onMounted, provide, ref } from "vue";
import useMagnoliaContent from "~/composables/useMagnoliaContent";
import useMyBritaUser from "~/composables/useMyBritaUser";
import PageLayout from "~/templates/partials/PageLayout";
import EditorAnnotationElements from "~/templates/elements/editor/EditorAnnotationElements.vue";
import LoadingElement from "~/templates/elements/LoadingElement.vue";

const config = {
  componentMappings,
  fallbackComponent: DefaultFallbackComponent,
};

const { initMagnoliaContext, loadTemplateAnnotations, contentPath, editorContext } =
  useMagnoliaContext();

const isEditMode = editorContext.value.isMagnoliaEdit;
const isMagnoliaPreview = editorContext.value.isMagnoliaPreview;
// const isEditMode = evaluateEditMode();

const { content, loadContent } = useMagnoliaContent();

if (import.meta.client) {
  // update mgnl context on client side navigations
  await initMagnoliaContext();
  // load page content
  await loadContent(contentPath.value);
}

// check content restrictions based on content
const { validateContent } = useMyBritaUser();

if (!isEditMode) {
  await validateContent(content);
}

// set page meta / seo information
usePageMeta();

// defaults
provide("fallbackComponent", DefaultFallbackComponent);

const templateAnnotations = ref({});

onMounted(async () => {
  useScrollTracking();
  if (content?.value?.cMasterPage === true) {
    //  early return if content master page
    return;
  }

  if (isEditMode || isMagnoliaPreview) {
    // call template annotation api from client
    const annotations = await loadTemplateAnnotations();

    if (Object.keys(annotations ?? {}).length > 0) {
      // assign template annotation only if page has areas / has not been filtered due to rights & roles
      templateAnnotations.value = annotations;

      let mgnlEditBarChecks = 0;
      const checkEditBars = () => {
        const element = document.querySelector(".mgnlEditorBar");
        mgnlEditBarChecks++;
        if (element) {
          // found editbars
          console.info("mgnl: editbars found");
          clearInterval(intervalId);
        } else if (mgnlEditBarChecks < 10) {
          // tell mgnl that frame is ready
          console.info("mgnl: no editbars, try to notify mgnl");
          globalThis?.mgnlFrameReady?.();
        } else {
          // tell mgnl that frame is ready
          console.info(`mgnl: could not initialize editbars after' ${mgnlEditBarChecks} attempts`);
          clearInterval(intervalId);
        }
      };

      const intervalId = setInterval(checkEditBars, 1000);
    }
  }
});
</script>

<script>
export default {
  name: "SlugPage",
};
</script>
